const AbstractPaymentMethodConfig = require('@/lib/PaymentMethods/AbstractPaymentMethodConfig');
const { toInt, toString } = require('@/functions/transform');

class WorldpayConfig extends AbstractPaymentMethodConfig {
    constructor() {
        super();

        /**
         * IP address of the computer running Worldpay IPC.
         * Most likely localhost.
         *
         * @type {string}
         */
        this.terminalHost = '127.0.0.1';

        /**
         * Port for the 'integration socket' connection to the terminal.
         *
         * @type {number}
         */
        this.terminalPort = 10000;

        /**
         * If true ProPoint will print receipts received on the receipt socket instead of IPC printing the receipts.
         * (This flag doesn't disable IPC printing them itself too - you need to disable that using YESEFTConfig)
         *
         * @type {boolean}
         */
        this.printReceipts = true;

        /**
         * Port for the 'receipt socket' connection to the terminal.
         *
         * @type {number}
         */
        this.receiptPort = 20000;
    }

    getHydrationMap() {
        return {
            terminalHost: toString,
            terminalPort: toInt,
        };
    }
}

module.exports = WorldpayConfig;
